import { Routes } from '@angular/router'
import { AddCallPageComponent } from './add-call-page/add-call-page.component'
import { adminGuard } from './admin.guard'
import { AppPageComponent } from './app-page/app-page.component'
import { authGuard } from './auth.guard'
import { CallAccessRequestApprovePageComponent } from './call-access-request-approve-page/call-access-request-approve-page.component'
import { CallPageComponent } from './call/call-page.component'
import { CallsDashboardComponent } from './calls-dashboard/calls-dashboard.component'
import { HangUpPageComponent } from './hang-up-page/hang-up-page.component'
import { LoginPageComponent } from './login-page/login-page.component'
import { SettingsPageComponent } from './settings-page/settings-page.component'
import { CallSetupPageComponent } from './call-setup-page/call-setup-page.component'
import { TemplatePlaygroundPage } from './template-playground-page/template-playground-page'
import { unsavedChangesGuard } from './unsaved-changes.guard'
import { TrainingPageComponent } from './training-page/training-page.component'
import { UploadCallPageComponent } from './upload-call-page/upload-call-page.component'
import { TeamsConsentComponent } from './teams/teams-consent.component'
import { TeamsPanelComponent } from './teams/teams-panel.component'
import { TeamsRouterComponent } from './teams/teams-router.component'

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'app',
  },
  {
    path: 'login',
    component: LoginPageComponent,
  },
  {
    path: 'teams',
    children: [
      { path: 'router', component: TeamsRouterComponent },
      { path: 'panel', component: TeamsPanelComponent },
      { path: 'consent', component: TeamsConsentComponent },
    ],
  },
  {
    path: 'meetings/:id/hang-up',
    pathMatch: 'full',
    component: HangUpPageComponent,
  },
  {
    path: 'app',
    component: AppPageComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'meetings/past',
      },
      // TODO Remove this after a while
      {
        path: 'calls/:id',
        redirectTo: '/app/meetings/:id',
      },
      {
        path: 'calls',
        redirectTo: '/app/meetings',
      },
      {
        path: 'meetings',
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'past',
          },
          {
            path: 'past',
            component: CallsDashboardComponent,
            data: {
              mode: 'OWN_CALLS',
            },
          },
          {
            path: 'shared-with-me',
            component: CallsDashboardComponent,
            data: {
              mode: 'SHARED_WITH_ME',
            },
          },
          {
            path: 'new',
            component: AddCallPageComponent,
          },
          {
            path: ':id',
            component: CallPageComponent,
            canDeactivate: [unsavedChangesGuard],
          },
          {
            path: ':id/setup',
            component: CallSetupPageComponent,
            canDeactivate: [unsavedChangesGuard],
          },
          {
            path: ':id/template',
            component: TemplatePlaygroundPage,
            canDeactivate: [unsavedChangesGuard],
          },
          {
            path: ':id/admin',
            redirectTo: ({ params }) => {
              const callId = params['id']
              return `/app/admin/meetings/${callId}`
            },
          },
          {
            path: ':id/approve-access-request',
            component: CallAccessRequestApprovePageComponent,
          },
        ],
      },
      {
        path: 'settings',
        pathMatch: 'full',
        redirectTo: 'settings/calendar',
      },
      {
        path: 'settings/:section',
        component: SettingsPageComponent,
      },
      {
        path: 'import',
        component: UploadCallPageComponent,
      },
      {
        path: 'training',
        component: TrainingPageComponent,
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin/routes').then((module) => module.adminRoutes),
        canActivate: [adminGuard],
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'app',
  },
]
